const Utils = require("../common/Utils");

/**
 * @abstract
 * @class
 */
const ResourcesRenderer = function() {
    const self = this;

    const iconColors = [
        ["#1C1C1B", "#575756"],
        ["#325570", "#BCCBD4"],
        ["#F7A914", "#FCEA0F"],
        ["#F39200", "#F9B233"],
        ["#BE1621", "#E6332A"],
        ["#009245", "#8DBF43"],
        ["#009E8B", "#37B9C6"],
        ["#245EA9", "#2F8EA9"],
        ["#27285B", "#0C71B8"],
        ["#3797D3", "#44C0EF"],
        ["#44C0EF", "#8DD0DF"],
        ["#6E468C", "#AD73AC"],
        ["#A2195B", "#E61D72"],
        ["#4B4998", "#662382"]
    ];

    function getLockBadge(size) {
        return '<svg xmlns="http://www.w3.org/2000/svg" width="' + size + '" height="' + size + '" viewBox="0 0 32 32">' +
        '<circle cx="16" cy="16" r="15" stroke="white" />' +
        '<path d="M9,14v11h14v-11M10,14v-3c0-3.3 2.7-6 6-6c3.3,0 6,2.7 6,6v3h-2v-3c0-2.2-1.8-4-4-4-2.2,0-4,1.8-4,4v3" fill="white" />' +
        "</svg>";
    }

    const LIST_VIEW_BADGE_SIZE = 24;
    const ICON_VIEW_BADGE_SIZE = 32;

    this.getListViewBadgeSize = function() {
        return LIST_VIEW_BADGE_SIZE;
    };

    this.getIconViewBadgeSize = function() {
        return ICON_VIEW_BADGE_SIZE;
    };

    this.getColorIndex = function(resource) {
        return resource._hash % iconColors.length;
    };

    this.getColorPair = function(resource) {
        return iconColors[self.getColorIndex(resource)];
    };

    /**
     * @abstract
     *
     * @param {ResourcesModel~ResourceItem} resource
     * @param {number} [scale]
     *
     * @returns {jQuery}
     */
    this.render = function(resource, scale) {};

    this.renderResourceListViewIcon = function(resource) {
        const $listIcon = $("<div>", {class : "listViewStatusIcon"});

        // Dynamic State takes precedence over connected state
        if (resource.dyn_state !== "Disabled") {
            // Only add this class if there's no connected state
            const $badge = self.renderResourceListViewBadge(resource);
            if ($badge === undefined) {
                $listIcon.addClass("noStatus");
            } else {
                $listIcon.append($badge);
            }
        } else {
            $listIcon.addClass("locked");
            $listIcon.append(getLockBadge(this.getListViewBadgeSize()));
        }
        return $listIcon;
    };

    /**
     * @param {ResourcesModel~ResourceItem} resource
     *
     * @returns {jQuery}
     */
    this.renderResourceListViewBadge = function(resource) {
        return undefined;
    };

    this.hasCustomIcon = function(resource) {
        return resource.icon && resource.icon.length > 0;
    };

    this.renderCustomIcon = function(resource) {
        const iconPath = (Utils.isGreaterThanOrEqualToServerVersion(CudaLaunch.serverConfiguration.version, "7.0.0"))
            ? "/portal/icons/"
            : "/_intmenu/icons/";

        const classes = ["ui-li-thumb"];
        if (resource.dyn_state === "Disabled") {
            classes.push("customLocked");
        }

        const $div = $("<div/>");
        $div.append($("<img/>", {
            alt : resource.name, // Is this safe?
            src : App.getRemoteUrlPrefix() + iconPath + resource.icon,
            class : classes.join(" ")
        }));
        return $div;
    };

    this.renderStandardIcon = function(resource) {
        // Use css to draw a shaded shape with text
        const iconText = this.getResourceIconText(resource);
        const fontSize = Math.min(72, 100.0 / iconText.length);

        let style;
        if (resource.dyn_state === "Disabled") {
            style = "background: #bbbbbb;";
        } else {
            const colorPair = this.getColorPair(resource);
            style = "background: linear-gradient(" + colorPair[0] + ", " + colorPair[1] + ");" +
                "background: -webkit-linear-gradient(" + colorPair[0] + ", " + colorPair[1] + ");";
        }

        return $("<div>", {
            style : style + "font-size: " + fontSize + "px;",
            class : "ui-li-thumb",
            text : iconText
        });
    };

    /**
     * If this resource is a dynamic resource that is currently disabled, add a padlock badge
     *
     * @param resource
     * @param extraClasses
     *
     * @returns {jQuery|HTMLElement|undefined}
     */
    this.renderStateBadge = function(resource, extraClasses) {
        if (resource.dyn_state !== "Disabled") {
            return undefined;
        }
        extraClasses.push("resourceBadgeContainer");
        if (self.hasCustomIcon(resource)) {
            extraClasses.push("custom_locked");
        } else {
            extraClasses.push(resource.type + "_locked");
        }
        const $div = $("<div>", {class : extraClasses.join(" ")});
        $div.append(getLockBadge(self.getIconViewBadgeSize()));
        return $div;
    };

    this.getResourceIconText = function(resource) {
        let name = resource.name;
        name = name.toUpperCase();
        const parts = name.split(" ");

        if (parts.length > 1) {
            let retVal = "";

            for (let i = 0; i < parts.length && i < 4; i++) {
                retVal += parts[i].substring(0, 1);
            }
            return retVal;
        }

        if (name.length <= 4) {
            return name;
        }

        return name.substring(0, 1);
    };

    /**
     * @abstract
     * @param {jQuery} element
     * @param {ResourcesModel~ResourceItem} resource
     */
    this.updateIcon = function(element, resource) {};
};

module.exports = ResourcesRenderer;